import React from "react";
import { BOT_CHANNEL } from "../../../../contexts/bots/BotsContext";
import { useTranslation } from "../../../../hooks/useLocalization";
import { WordpressColoredIcon } from "../bodies/Wordpress";
import ChannelCard from "./ChannelCard";

const ChannelWordpressCard = (props) => {
  const { t } = useTranslation();
  const { channelName, handlers } = props;
  return (
    <ChannelCard
      {...props}
      name={t(BOT_CHANNEL.title(channelName))}
      icon={WordpressColoredIcon}
      handlers={handlers}
    />
  );
};

export default ChannelWordpressCard;
